import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-order-status',
  templateUrl: './user-order-status.component.html',
  styleUrls: ['./user-order-status.component.scss'],
})
export class UserOrderStatusComponent {
  @Input() status = '';

  constructor() {}
}
